import { render, staticRenderFns } from "./accept-tos.vue?vue&type=template&id=276fd6f2"
import script from "./accept-tos.vue?vue&type=script&lang=js"
export * from "./accept-tos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./accept-tos.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports